<div class="app-shell">
  <div class="top-nav-display-container">
    @if (!isProjectOverview()) {
      <div class="top-nav-display-container__project-info">
        <h1>{{selectedProject()?.displayName}}</h1>
        <h2>{{selectedProject()?.contractNr}}</h2>
      </div>
      <div class="top-nav-display-container__actions">
        <h1>QS-App</h1>
        <div style="font-size: 0.85rem; color: gray;">
          {{ currentUser()?.displayName ?? 'Nicht angemeldet' }}
        </div>
      </div>
    }
  </div>
  @if (!isProjectOverview()) {<app-top-sub-nav/>}
  @if (!isProjectOverview()) {<mat-divider></mat-divider>}
  <main>
    <router-outlet />
  </main>
</div>
